export const postLesson = {
  // 평가 선택지
  rating5: '최고였어요!',
  rating4: '좋았어요',
  rating3: '보통이었어요',
  rating2: '아쉬웠어요',
  rating1: '별로였어요',

  // 유효성 검사
  validationRating: '레슨 평가를 선택해 주세요',
  validationNextDate: '다음 희망 일시를 입력해 주세요',
  loginRequired: '로그인이 필요합니다',

  // 전송 완료
  doneTitle: '전송 완료!',
  doneBody: '폼을 제출해 주셔서 감사합니다.<br />다음 레슨 일정이 정해지면 다시 이메일로 안내드리겠습니다!',
  toMyPage: '마이페이지로',

  // 헤더
  heading: '레슨 후 폼',
  subtitle: '수고하셨습니다! 배운 내용과 다음 희망 사항을 보내주세요 ✨',

  // 섹션
  ratingTitle: '레슨 평가',
  nextScheduleTitle: '다음 희망 일시',
  timezoneLabel: '시간대：',
  dateLabel: '날짜',
  timeLabel: '시간',
  timePlaceholder: '선택',
  wordPoolTitle: 'Word Pool 등록 문구',
  wordPoolHelper: '오늘 레슨에서 배운 문구를 한 줄씩 입력해 주세요(선택). 이후 Admin 심사를 거쳐 공개됩니다.',
  phrasesPlaceholder: '예：\n오츠카레사마\n나루호도\n요로시쿠 오네가이시마스',
  notesTitle: '비고·소감',
  notesPlaceholder: '신경 쓰인 점·운영진에게 보내는 메시지 등(선택)',

  // 전송
  submitting: '전송 중...',
  submit: '폼 전송하기',
};
